import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Icon, Message, Transition } from "semantic-ui-react";

import EntityLink from "../utils/EntityLink.jsx";

class NotificationMessage extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.string,
    title: PropTypes.string.isRequired,
    message: PropTypes.string,
    objectEntity: PropTypes.object,
    info: PropTypes.bool.isRequired,
    positive: PropTypes.bool.isRequired,
    warning: PropTypes.bool.isRequired,
    negative: PropTypes.bool.isRequired,
    color: PropTypes.string,
    iconColor: PropTypes.string,
    dismissable: PropTypes.bool.isRequired,
    timed: PropTypes.bool.isRequired,
    time: PropTypes.number,
    duration: PropTypes.number,
    onDismiss: PropTypes.func.isRequired
  };

  static defaultProps = {
    info: false,
    positive: false,
    warning: false,
    negative: false,
    dismissable: true,
    timed: false,
    time: 5000,
    duration: 1000,
    onDismiss: () => {}
  };

  constructor(props) {
    super(props);

    this.hideTimeout = null;

    this.state = {
      visible: true,
      hideTimeout: null
    };
  }

  // -- TIMED MESSAGE -- //

  componentDidMount() {
    const { timed, time } = this.props;
    if (timed === true) {
      this.hideTimeout = setTimeout(this.hideMessage, time);
    }
    this.setState({ visible: true });
  }

  componentWillUnmount() {
    clearTimeout(this.hideTimeout);
  }

  hideMessage = () => {
    this.setState({ visible: false });
  };

  doDismiss = () => {
    const { id, onDismiss } = this.props;
    onDismiss(id);
  };

  // -- RENDER -- //

  getIcon = () => {
    const { icon, negative, positive, warning, info } = this.props;

    if (icon) return icon;
    if (positive) return "check circle";
    if (negative || warning || info) return "exclamation circle";

    return "bug";
  };

  getObjectEntity = () => {
    const { objectEntity } = this.props;

    if (objectEntity && objectEntity["@id"]) {
      return objectEntity;
    }

    return {};
  };

  renderMessage() {
    const {
      title,
      message,
      dismissable,
      negative,
      positive,
      warning,
      info,
      color,
      iconColor,
      attached,
      className,
      children,
      style
    } = this.props;

    const fullClassName = className
      ? `segment-message notification-message ${className}`
      : "segment-message notification-message";

    return (
      <Message
        color={color}
        negative={negative}
        positive={positive}
        warning={warning}
        info={info}
        onDismiss={dismissable ? this.hideMessage : null}
        attached={attached}
        icon
        size="small"
        className={fullClassName}
        style={style}
      >
        <Icon name={this.getIcon()} color={iconColor} />
        <EntityLink style={{ width: "100%" }} entity={this.getObjectEntity()}>
          <Message.Content>
            <Message.Header>{title}</Message.Header>
            {message && <p>{message}</p>}
          </Message.Content>
          {children}
        </EntityLink>
      </Message>
    );
  }

  render() {
    const { duration } = this.props;
    const { visible } = this.state;

    return (
      <Transition
        visible={visible}
        animation="fade"
        duration={duration}
        transitionOnMount={true}
        onHide={this.doDismiss}
      >
        {this.renderMessage()}
      </Transition>
    );
  }
}

export default NotificationMessage;
